import { useParams } from "react-router";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { ItemsTable } from "@/services/backend/htz/report/components/items-table";
import { AssignAhuForReportDialog } from "@/services/backend/htz/report/components/assign-ahu-for-report-dialog";
import { ReportAhuSchema } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/items/_components/report-ahu-schema";
import { ReportAhuEditSheet } from "@/services/backend/htz/report/components/report-ahu-edit-sheet";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import t from "@/lang/lang";

export function ItemsRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);

  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  if (isLoading) {
    return <CardSkeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Komponenten")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie eine Zusammenfassung der einzelnen Bewertungen für alle Komponenten sehen.",
          )}
        </CardDescription>
        {report && report.ahuId && !isImmutable(report) && (
          <CardAction>
            <ReportAhuEditSheet report={report} />
          </CardAction>
        )}
      </CardHeader>
      <CardContent className="space-y-4">
        {report && !report.ahuId ? (
          // Without an air handling unit there is no ahu data to show the
          // schema and the components of.
          <div className="flex flex-col items-start gap-4">
            <p className="text-muted-foreground text-sm">
              {t("Dem Anlagenbericht ist noch keine RLT-Anlage zugewiesen.")}
            </p>
            {!isImmutable(report) && (
              <AssignAhuForReportDialog report={report} />
            )}
          </div>
        ) : (
          <>
            <ReportAhuSchema report={report!} />
            {!isImmutable(report!) && (
              <p className="text-muted-foreground text-sm">
                {t(
                  "Nach Änderungen an den Komponenten muss das Schema über „Zum Bericht hinzufügen“ erneut gespeichert werden, damit der Bericht und das PDF es aktuell zeigen.",
                )}
              </p>
            )}
            <ItemsTable report={report!} />
          </>
        )}
      </CardContent>
    </Card>
  );
}
